import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { MinistryFocusSection } from './components/MinistryFocusSection';
import { SermonsSection } from './components/SermonsSection';
import { EventsSection } from './components/EventsSection';
import { BooksSection } from './components/BooksSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GallerySection } from './components/GallerySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream text-charcoal font-inter selection:bg-gold selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <MinistryFocusSection data-id="element-5" />
        <SermonsSection data-id="element-6" />
        <EventsSection data-id="element-7" />
        <BooksSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GallerySection data-id="element-10" />
        <ContactSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}